// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// <summary>
/// Обертка вектора результата
/// </summary>
export class ResVector {
    constructor(rowNumber, timeShift, priceMult, vector) {
        this.FRowNumber = rowNumber;
        this.FTimeShift = timeShift;
        this.FPriceMult = priceMult;
        this.Vector = vector;
    }
    get TimeShift() {
        return this.FTimeShift[this.FRowNumber];
    }
    // #region IDoubleVector Members
    get(index) {
        const priceMult = this.FPriceMult[this.FRowNumber];
        return index >= 0 && index < this.Vector.Length ? this.Vector.get(index) * priceMult : 0.0;
    }
    set(index, value) {
        this.Vector.set(index, value);
    }
    get Length() {
        return this.Vector.Length;
    }
    // #endregion
    Dispose() {
        if (this.Vector != null) {
            this.Vector.Dispose();
            this.Vector = null;
        }
    }
}
